import React, { Fragment, useState } from "react";
import Select from "react-select";
import DisplaySelectedOptionsList from "../common/DisplaySelectedOptionsList";
import AgencyDashboardNewRequirementsCard from "./AgencyDashboardNewRequirementsCard";

const cardData = [{ isBookMarked: false }, { isBookMarked: true }];

const optionsSkill = [
  { value: "Skill Name 1", label: "Skill Name 1" },
  { value: "Skill Name 2", label: "Skill Name 2" },
  { value: "Skill Name 3", label: "Skill Name 3" },
  { value: "Skill Name 4", label: "Skill Name 4" },
  { value: "Skill Name 5", label: "Skill Name 5" },
  { value: "Skill Name 6", label: "Skill Name 6" },
];

const optionsResources = [
  { value: "1 Resources", label: "1 Resources" },
  { value: "2 Resources", label: "2 Resources" },
];

const optionsPayRate1 = [
  { value: "4", label: "$4" },
  { value: "5", label: "$5" },
];

const optionsPayRate2 = [
  { value: "6", label: "$6" },
  { value: "7", label: "$7" },
];

const optionsSortBy = [{ value: "Latest to older", label: "Latest to older" }];

const optionsLocation = [{ value: "Remote", label: "Remote" }];

const optionsUrgency = [{ value: "This week", label: "This week" }];

const optionsBillingType = [{ value: "Monthly", label: "Monthly" }];

export default function AgencyDashboardNewRequirements() {
  const [values, setValues] = useState({
    activeIndex: 0,
    selectedValSkill: "",
    displayListSelected: [],
    selectedValResources: "",
    selectedValPayRate1: "",
    selectedValPayRate2: "",
    selectedValSortBy: "",
    selectedValLocation: "",
    selectedValUrgency: "",
    selectedValBillingType: "",
  });

  const handleChangeDropdownSkill = (selectedOption) => {
    let newList = values.displayListSelected;
    if (newList.indexOf(selectedOption) === -1) {
      newList.push(selectedOption);
      setValues({
        ...values,
        selectedValSkill: selectedOption,
        displayListSelected: newList,
      });
    } else {
      setValues({
        ...values,
        selectedValSkill: selectedOption,
      });
    }
  };

  const handleRemoveMember = (index) => (e) => {
    let newList = values.displayListSelected;
    newList.splice(index, 1);
    setValues({
      ...values,
      displayListSelected: newList,
      selectedValSkill: "",
    });
  };

  const handleChangeDropdownResources = (selectedOption) => {
    setValues({ ...values, selectedValResources: selectedOption });
  };

  const handleChangeDropdownPayRate1 = (selectedOption) => {
    setValues({ ...values, selectedValPayRate1: selectedOption });
  };

  const handleChangeDropdownPayRate2 = (selectedOption) => {
    setValues({ ...values, selectedValPayRate2: selectedOption });
  };

  const handleChangeDropdownSortBy = (selectedOption) => {
    setValues({ ...values, selectedValSortBy: selectedOption });
  };

  const handleChangeDropdownLocation = (selectedOption) => {
    setValues({ ...values, selectedValLocation: selectedOption });
  };

  const handleChangeDropdownUrgency = (selectedOption) => {
    setValues({ ...values, selectedValUrgency: selectedOption });
  };

  const handleChangeDropdownBillingType = (selectedOption) => {
    setValues({ ...values, selectedValBillingType: selectedOption });
  };

  const renderNumOfResourcesDropdown = () => {
    return (
      <>
        <p className="font-14-NunitoSans-600 mt-agency-dashboard-label">
          <img src="/img/desktop/icons/white-people-icon.svg" alt="" />
          No of Resources
        </p>
        <div className="react-select-agency-dashboard-resources">
          <Select
            className="react-select-container"
            classNamePrefix="react-select-elements"
            isSearchable={false}
            options={optionsResources}
            value={values.selectedValResources}
            onChange={handleChangeDropdownResources}
            placeholder="Select"
          />
          {/* display error */}
        </div>
      </>
    );
  };

  return (
    <>
      <div className="custom-d-flex align-items-start agency-dashboard-new-req-row">
        <div className="agency-dashboard-new-req-row__colm1">
          <div className="mb-41">
            <p className="font-14-NunitoSans-600 mt-agency-dashboard-label">
              <img src="/img/desktop/icons/white-star-icon.svg" alt="" />
              Skills
            </p>
            <div className="react-select-agency-dashboard-new-req-skills">
              <Select
                className="react-select-container"
                classNamePrefix="react-select-elements"
                options={optionsSkill}
                value={values.selectedValSkill}
                onChange={handleChangeDropdownSkill}
                placeholder="Select"
                isSearchable={true}
              />
              {/* display error */}
            </div>
            <DisplaySelectedOptionsList
              displayListSelected={values.displayListSelected}
              handleRemoveMember={handleRemoveMember}
            />
          </div>
          <div className="mb-41">
            <p className="font-14-NunitoSans-600 mt-agency-dashboard-label">
              <img src="/img/desktop/icons/white-location-icon.svg" alt="" />
              Location
            </p>
            <div className="react-select-agency-dashboard-billing-type">
              <Select
                className="react-select-container"
                classNamePrefix="react-select-elements"
                isSearchable={false}
                options={optionsLocation}
                value={values.selectedValLocation}
                onChange={handleChangeDropdownLocation}
                placeholder="Select"
              />
              {/* display error */}
            </div>
          </div>
          <div className="mb-41">
            <p className="font-14-NunitoSans-600 mt-agency-dashboard-label">
              <img src="/img/desktop/icons/white-calendar-icon.svg" alt="" />
              Urgency
            </p>
            <div className="react-select-agency-dashboard-billing-type">
              <Select
                className="react-select-container"
                classNamePrefix="react-select-elements"
                isSearchable={false}
                options={optionsUrgency}
                value={values.selectedValUrgency}
                onChange={handleChangeDropdownUrgency}
                placeholder="Select"
              />
              {/* display error */}
            </div>
          </div>
          <div className="mb-41">
            <p className="font-14-NunitoSans-600 mt-agency-dashboard-label">
              <img
                src="/img/desktop/icons/white-billing-type-icon.svg"
                alt=""
              />
              Billing Type
            </p>
            <div className="react-select-agency-dashboard-billing-type">
              <Select
                className="react-select-container"
                classNamePrefix="react-select-elements"
                isSearchable={false}
                options={optionsBillingType}
                value={values.selectedValBillingType}
                onChange={handleChangeDropdownBillingType}
                placeholder="Select"
              />
              {/* display error */}
            </div>
          </div>
          <div className="mb-41 d-block d-md-none">
            {renderNumOfResourcesDropdown()}
          </div>
        </div>

        <div className="agency-dashboard-new-req-row__colm2">
          <div className="custom-d-flex align-items-start">
            <div className="mr-30 d-none d-md-block">
              {renderNumOfResourcesDropdown()}
            </div>
            <div className="mr-30 mb-41">
              <p className="font-14-NunitoSans-600 mt-agency-dashboard-label mt-agency-dashboard-label--rate">
                <img src="/img/desktop/icons/white-dollar-icon.svg" alt="" />
                Rate <span className="color-white-29">(in $/Hr/Resource)</span>
              </p>
              <div className="d-flex align-items-center">
                <div className="react-select-agency-dashboard-pay-rate">
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select-elements"
                    isSearchable={false}
                    options={optionsPayRate1}
                    value={values.selectedValPayRate1}
                    onChange={handleChangeDropdownPayRate1}
                    placeholder="Select"
                  />
                  {/* display error */}
                </div>
                <span className="react-select-agency-dashboard-pay-rate__dash">
                  -
                </span>
                <div className="react-select-agency-dashboard-pay-rate">
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select-elements"
                    isSearchable={false}
                    options={optionsPayRate2}
                    value={values.selectedValPayRate2}
                    onChange={handleChangeDropdownPayRate2}
                    placeholder="Select"
                  />
                  {/* display error */}
                </div>
              </div>
            </div>
            <div className="mb-41">
              <p className="font-14-NunitoSans-600 mt-agency-dashboard-label">
                <img src="/img/desktop/icons/white-sort-icon.svg" alt="" />
                Sort by
              </p>
              <div className="react-select-agency-dashboard-resources">
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select-elements"
                  isSearchable={false}
                  options={optionsSortBy}
                  value={values.selectedValSortBy}
                  onChange={handleChangeDropdownSortBy}
                  placeholder="Select"
                />
                {/* display error */}
              </div>
            </div>
          </div>
          <hr className="mt-common-card__hr-2 mt-0" />
          <h3 className="font-16-NunitoSans-600 mb-27 pt-25 pl-22 color-white-35 mobile-text-gradient-1">
            List of Requirements found
          </h3>
          {cardData.map((data, index) => (
            <Fragment key={index}>
              <AgencyDashboardNewRequirementsCard cardData={data} />
            </Fragment>
          ))}
        </div>
      </div>
    </>
  );
}
